var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cw-list-cell',{staticClass:"has-border-bottom",attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"disclosureDetail":`${(_vm.boxSetInfo.box && _vm.boxSetInfo.box.boxNumber) || ''}`,"leftIconProps":{
    badge: _vm.boxSizeString,
    scale: 'is-medium',
    colorClass: 'tag is-steel',
  }},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }